import { GzRmSeverityBar } from './component/GzRmSeverityBar';

export { GzRmSeverityBar };
